import { render, staticRenderFns } from "./SuggestedProductSlider.vue?vue&type=template&id=4d5a5fd9&scoped=true&"
import script from "./SuggestedProductSlider.vue?vue&type=script&lang=js&"
export * from "./SuggestedProductSlider.vue?vue&type=script&lang=js&"
import style0 from "./SuggestedProductSlider.vue?vue&type=style&index=0&id=4d5a5fd9&scoped=true&lang=css&"
import style1 from "./SuggestedProductSlider.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5a5fd9",
  null
  
)

export default component.exports